<template>
  <div class="model-content-all">
    <div style="height: 120px;">
      <div class="flex justify-between align-items-center">
        <div class="flex justify-start align-center">
<!--          <div class="margin-right cursor-pointer" @click="toMerBack">-->
<!--            <a-image :src="require('@/assets/footer/store.png')" :preview="false" width="28px"-->
<!--                     height="28px"></a-image>-->
<!--          </div>-->
<!--          <div class="margin-right cursor-pointer" @click="toTRX">-->
<!--            <a-image :src="require('@/assets/footer/trxusdt.png')" :preview="false" width="28px"-->
<!--                     height="28px"></a-image>-->
<!--          </div>-->
<!--          <div class="margin-right cursor-pointer" @click="toChaU">-->
<!--            <a-image :src="require('@/assets/footer/USDT.png')" :preview="false" width="28px" height="28px"></a-image>-->
<!--          </div>-->
        </div>
        <div class="copyright text-white margin-right">
          <p>Copyright © {{ year }} 卡馬特有限公司 保留所有权利</p>
          <div class="text-white  global-btn" @click="toPrivacyPolicy">隐私协议</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  data() {
    return {
      config: require('@/config'),
      year: new Date().getFullYear(), // 当前年份
    }
  },
  methods: {
    toPrivacyPolicy(){
      this.$router.push({path: "/privacyPolicy"});
    },
    toMerBack() {
      window.open('https://www.51danbao.com', '_blank')
    },
    toTRX() {
      window.open('https://t.me/chau51_bot', '_blank')
    },
    toChaU() {
      window.open('https://www.51chau.com/', '_blank')
    },
  },
}
</script>

<style scoped>
.model-content-all {
  width: 100%;
  border-top:1px solid #313131;
  margin: 0 auto;
  background-color: #272727;
  padding: 90px 20px 10px 20px !important;
}

</style>
